module.exports = __webpack_public_path__ + "static/media/logo_icon_rgb_big.e4965573.png";